import DiscountDetailModal from 'components/DiscountDetailModal';
import Layout from 'components/Layout';
import OrderRemarkModal from 'components/OrderRemarkModal';
import SearchSelect from 'components/OrderSearchSelector';
import DiscountActivityDetailModal from 'components/orderList/DiscountActivityDetailModal';
import { useFormik } from 'formik';
import moment from 'moment';
import RcPagination from 'rc-pagination';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { FaChevronDown } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Card, Input, Spinner, Table } from 'reactstrap';
import { getOrderList, getOrderOptions } from 'redux/actions/data/orderActions';
import {
  getUUOptions,
  storeCancel,
} from 'redux/actions/data/orderShippingActions';
import { STORE_CANCEL_RESET } from 'redux/constants/data/orderShippingConstants';
import CommonUtil from 'utils/CommonUtil';
import MessageUtil from 'utils/MessageUtil';
import history from 'utils/createHistory';
import { useToggle } from 'utils/customHooks';
import useQuery from 'utils/useQuery';

import TableHasNoData, { TableLoading } from '../components/TableHasNoData';
import style from '../styles/layout.module.css';
import { modal } from '../utils/modal';

const TableList = ({
                     onChangePage,
                     onActionOne,
                     onActionCancelOne,
                     onAction,
                     onActionCancel,
                     onToggleOrderRemarkModal,
                     setOrderInfo,
                     onToggleDiscountActivityModal,
                     setCurrentOrderItemId,
                   }) => {
  const { loading, orderListInfo, error } = useSelector(
      state => state.orderList,
  );
  const { values, setFieldValue, handleReset } = useFormik({
    enableReinitialize: true,
    initialValues: {
      all: false,
      list: [],
    },
  });
  const handleSubmit = type => {
    type === 1 && onAction && onAction(values, handleReset);
    type === 2 && onActionCancel && onActionCancel(values, handleReset);
  };

  const isSticky = orderListInfo?.datas?.length > 0 ? { height: '80vh' } : {};

  return (
      <Card className={style.card}>
        <div className="mb-3 " style={{ margin: '0.5rem' }}>
          <Button
              className="me-2"
              color="success"
              disabled={values.list.length <= 0}
              onClick={() => handleSubmit(1)}
              style={{ marginRight: '0.5rem' }}
          >
            已取貨
          </Button>
          <Button
              color="success"
              disabled={values.list.length <= 0}
              onClick={() => handleSubmit(2)}
          >
            取消訂單
          </Button>
        </div>
        <div className="table-responsive" style={isSticky}>
          <Table hover bordered striped className="mb-5">
            <thead
                className={`thead-dark ${style.table_head} ${style['form-table-header-sticky']}`}
            >
            <tr>
              <th>
                <input
                    className={style.maintain_list_checkbox}
                    type="checkbox"
                    name="all"
                    onChange={e => {
                      const val = e.target.checked;
                      setFieldValue(
                          'list',
                          val ? orderListInfo?.datas?.map(i => i.id) : [],
                      );
                    }}
                    checked={
                        values.list.length > 0 &&
                        values.list.length === orderListInfo?.datas?.length
                    }
                />{' '}
                全選
              </th>
              <th>訂單編號</th>
              <th>
                <div>配送資訊</div>
              </th>
              <th>
                <div>轉單時間</div>
                <div>訂單確認時間</div>
              </th>
              <th>
                <div>出貨單狀態</div>
                <div>取貨截止日</div>
                <div>交期</div>
                <div>預計出貨日</div>
              </th>

              <th>
                <div>商品名稱</div>
                <div>商品選項</div>
                <div>商品料號</div>
                <div>商品屬性</div>
              </th>
              <th>
                <div>數量</div>
                <div>總銷售金額</div>
              </th>
              <th>
                <div>促銷/贈品</div>
              </th>
              <th>
                <div>收件人資訊</div>
                <div>取貨門市</div>
              </th>
              <th>
                <div>商店訂單備註</div>
              </th>
              <th>
                <div>訂單狀態</div>
              </th>
            </tr>
            </thead>
            {loading && <TableLoading />}
            {!loading && (
                <tbody>
                {orderListInfo?.datas?.length > 0 ? (
                    orderListInfo?.datas?.map(i => (
                        <React.Fragment key={JSON.stringify(i)}>
                          <tr className="text-nowrap bg">
                            <td>
                              <input
                                  className={style.maintain_list_checkbox}
                                  type="checkbox"
                                  onChange={e => {
                                    const val = e.target.checked;
                                    setFieldValue(
                                        'list',
                                        val
                                            ? [...values.list, i.id]
                                            : values.list.filter(j => j !== i.id),
                                    );
                                  }}
                                  checked={values.list.indexOf(i.id) > -1}
                              />
                            </td>
                            <td colSpan="2">
                              <div>主單編號：{i.orderNumber}</div>
                              {/* <div>訂購時間：{i.orderTime}</div> */}
                            </td>
                            <td colSpan={9}>
                              <div className="d-flex align-items-center">
                                <Button
                                    color="success"
                                    outline
                                    className="bg-white text-success me-2"
                                    onClick={() => onActionOne(i)}
                                >
                                  已取貨
                                </Button>
                                <Button
                                    color="success"
                                    outline
                                    className="bg-white text-success me-auto"
                                    onClick={() => onActionCancelOne(i)}
                                >
                                  取消訂單
                                </Button>
                                <FaChevronDown id={`orderId${i.id}`} />
                              </div>
                            </td>
                          </tr>
                          {i.orderItems.map((j, jIndex) => (
                              <tr key={jIndex}>
                                <td></td>
                                <td>
                                  {/* 訂單編號 */}
                                  <div>{j.orderItemNumber}</div>
                                </td>
                                <td>
                                  {/* 配送資訊 (配送方式 & 運費)*/}
                                  <div>{j.logisticsWayName}</div>
                                  <div>{'主單運費'}</div>
                                  <div>NT$ {i.deliveryCharge}</div>
                                </td>
                                <td>
                                  {/* 轉單時間 */}
                                  <div>{i.orderTime || '--'}</div>
                                  {/* 訂單確認時間 */}
                                  <div>{i.checkOrderTime}</div>
                                </td>
                                <td>
                                  {/* 出貨單狀態 */}
                                  <div>{j.shippingStatusName || '--'}</div>
                                  {/* 取貨截止日 */}
                                  <div>{j.pickUpDeadline || '--'}</div>
                                  {/* 交期 */}
                                  <div>{j.deliveryType === 1 ? '一般' : '預購'}</div>
                                  {/* 預計出貨日 */}
                                  <div>{j.expectedDeliveryDate || '--'}</div>
                                </td>
                                <td>
                                  {/* 商品名稱 */}
                                  <div>{j.productname || '--'}</div>
                                  {/* 商品選項 */}
                                  <div>
                                    {j.color || '--'}/{j.size || '--'}
                                  </div>
                                  {/* 商品料號 */}
                                  <div
                                      className={style.text_dark_info}
                                      style={{ cursor: 'pointer', fontSize: '16px' }}
                                      onClick={() => {
                                        if (Number(j.productType) === 4) {
                                          window.open(
                                              `/#/GiftManagement?page=1&keyword=${
                                                  j.productname || j.freebieCode
                                              }`,
                                              '_blank',
                                          );
                                        } else if (Number(j.productType) === 1) {
                                          window.open(
                                              `/#/ProductControl?page=1&keyword=${
                                                  j.productname || j.productcode
                                              }`,
                                              '_blank',
                                          );
                                        }
                                      }}
                                  >
                                    {Number(j.productType) === 4
                                        ? j.freebieCode || '--'
                                        : j.productcode || '--'}
                                  </div>
                                  {/* 商品屬性 */}
                                  <div>
                                    {Number(j.productType) === 4
                                        ? j.freebieType
                                        : '商品'}
                                  </div>
                                </td>
                                <td className="text-end">
                                  {/* 數量 */}
                                  <div>{j.quantity}</div>
                                  {/* 總銷售金額 */}
                                  <div className="price text-black fw-normal finalPrice">
                                    {(j.finalPrice || '0').toLocaleString('en-US')}
                                  </div>
                                  <div
                                      className={style.text_dark_info}
                                      style={{
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        textAlign: 'center',
                                      }}
                                      onClick={() => {
                                        modal.showBillInfo({
                                          ...j,
                                          orderNumber: i.orderNumber,
                                        });
                                      }}
                                  >
                                    查看明細
                                  </div>
                                </td>
                                <td>
                                  {/* 促銷/贈品 */}
                                  <div
                                      className={style.text_dark_info}
                                      style={{
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        textAlign: 'center',
                                      }}
                                      onClick={() => {
                                        setCurrentOrderItemId(j.id);
                                        onToggleDiscountActivityModal();
                                      }}
                                  >
                                    折扣活動明細
                                  </div>
                                </td>
                                <td>
                                  {/* 取件人資訊 */}
                                  <div>{j.name}</div>
                                  <div>{j.phone}</div>
                                  <div>{`${j.cityName || '--'}${j.townName || '--'}${
                                      j.address || '--'
                                  }`}</div>
                                  {/* 取件門市 */}
                                  <div>{j.orderStoreName || '--'}</div>
                                </td>
                                <td className="text-center">
                                  {/* 商店訂單備註 */}
                                  <div>{j.orderRemark || '--'}</div>
                                  <div
                                      className={style.text_dark_info}
                                      style={{ cursor: 'pointer', fontSize: '14px' }}
                                      onClick={() => {
                                        setOrderInfo({
                                          requestBody: {
                                            orderItemId: j.id,
                                            orderRemark: j.orderRemark,
                                          },
                                          主單編號: i.orderNumber,
                                          商品名稱: j.productname,
                                          訂單編號: j.orderItemNumber,
                                        });
                                        onToggleOrderRemarkModal();
                                      }}
                                  >
                                    編輯備註
                                  </div>
                                </td>
                                <td className="text-center">
                                  {/* 訂單狀態 */}
                                  <div>{j.orderItemStatusName}</div>
                                </td>
                              </tr>
                          ))}
                        </React.Fragment>
                    ))
                ) : (
                    <TableHasNoData />
                )}
                {error && <TableHasNoData />}
                </tbody>
            )}
          </Table>
          {loading && (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
          )}
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <RcPagination
              current={orderListInfo?.current_page || 1}
              pageSize={orderListInfo?.page_size || 10}
              total={orderListInfo?.total_count || 0}
              onChange={onChangePage}
          />
        </div>
      </Card>
  );
};
const StoreOrdersCancel = () => {
  const dispatch = useDispatch();
  const [orderInfo, setOrderInfo] = useState(null);
  const [isOrderRemarkModalOpen, setIsOrderRemarkModalOpen] = useToggle();
  const [isDiscountModalOpen, setIsDiscountModalOpen] = useToggle();
  const [isDiscountActivityModalOpen, setIsDiscountActivityModalOpen] =
      useToggle();
  const [currentId, setCurrentId] = useState(null);
  const { orderOptionsInfo } = useSelector(state => state.orderOptions);
  const { uuoptionsInfo } = useSelector(state => state.uuoptions);

  const [currentValues, setCurrentValues] = useState({});
  const query = useQuery();
  const { location } = history;

  useEffect(() => {
    dispatch(getOrderOptions());
    dispatch(getUUOptions());
  }, []);
  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    handleReset,
    setValues,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      deliveryType: 0,
      endTime: null,
      keyword: '',
      logisticsStatus: 4,
      logisticsWay: 4,
      notPickUpAfter10Days: true,
      orderNumber: '',
      orderNumberType: '主單編號',
      orderStatus: 2,
      page: 1,
      page_size: 10,
      shippingStatus: 2,
      startTime: null,
      suppliercode: '',
      timeType: '訂購時間',
    },
    onReset: () => {
      handleSubmit();
    },
    async onSubmit(formModel) {
      const body = {
        ...formModel,
        endTime: formModel.endTime
            ? moment(formModel.endTime).format('yyyy/MM/DD HH:mm:ss')
            : moment().format('yyyy/MM/DD HH:mm:ss'),
        startTime: formModel.startTime
            ? moment(formModel.startTime).format('yyyy/MM/DD HH:mm:ss')
            : moment().subtract(7, 'days').format('yyyy/MM/DD HH:mm:ss'),
      };

      if (CommonUtil.isValueChanged(currentValues, body, setCurrentValues)) {
        const params = new URLSearchParams({
          ...body,
          endTime: JSON.stringify(body.endTime),
          startTime: JSON.stringify(body.startTime),
        });
        history.push(`${location.pathname}?${params.toString()}&v=${new Date().getTime()}`);
      } else {
        CommonUtil.consoleLog({ anno: 'request body', data: body });
        dispatch(getOrderList(body));
      }
    },
  });

  useEffect(() => {
    if (location.search) {
      const body = {
        ...values,
        ...query.value,
        endTime: query.value.endTime
            ? JSON.parse(query.value.endTime)
            : moment().format('yyyy/MM/DD HH:mm:ss'),
        keyword: `${query.value.keyword || ''}`,
        notPickUpAfter10Days: true,
        orderNumber: `${query.value.orderNumber || ''}`,
        startTime: query.value.startTime
            ? JSON.parse(query.value.startTime)
            : moment().subtract(7, 'days').format('yyyy/MM/DD HH:mm:ss'),
      };
      CommonUtil.consoleLog({ anno: 'request body', data: body });
      dispatch(getOrderList(body));
      setValues(body);
    } else {
      handleReset();
    }
  }, [location.search]);

  const handleChangePage = n => {
    setFieldValue('page', n);
    handleSubmit();
  };

  const { success, error } = useSelector(state => state.storeCancel);
  const handleAction = (params, cb) => {
    MessageUtil.submitConfirm({
      doneFun: () => {
        dispatch(storeCancel(params.list));
        cb();
      },
      title: '確認取貨？',
    });
  };
  const handleActionOne = item => {
    MessageUtil.submitConfirm({
      doneFun: () => {
        dispatch(storeCancel([item.id]));
      },
      title: '確認取貨？',
    });
  };

  useEffect(() => {
    success && MessageUtil.toastSuccess('確認取貨成功!!');
    success && handleSubmit();
    return () => {
      dispatch({ type: STORE_CANCEL_RESET });
    };
  }, [success]);
  useEffect(() => {
    error && MessageUtil.alertWanring(error.message);
    return () => {
      dispatch({ type: STORE_CANCEL_RESET });
    };
  }, [error]);

  const { success: storeCancelSuccess, error: storeCancelError } = useSelector(
      state => state.storeCancel,
  );
  const handleActionCancel = params => {
    MessageUtil.submitConfirm({
      doneFun: () => {
        dispatch(storeCancel(params));
      },
      title: '確認取消訂單？',
    });
  };
  const handleActionCancelOne = item => {
    MessageUtil.submitConfirm({
      doneFun: () => {
        dispatch(storeCancel([item.id]));
      },
      title: '確認取消訂單？',
    });
  };

  useEffect(() => {
    storeCancelSuccess && MessageUtil.toastSuccess('訂單已取消!!');
    storeCancelSuccess && handleSubmit();
    return () => {
      dispatch({ type: STORE_CANCEL_RESET });
    };
  }, [storeCancelError]);

  useEffect(() => {
    storeCancelError && MessageUtil.alertWanring(error.message);
    return () => {
      dispatch({ type: STORE_CANCEL_RESET });
    };
  }, [storeCancelError]);

  return (
      <Layout
          pageTitle="消費者未取貨確認"
          items={[{ isActive: true, page_name: '消費者未取貨確認' }]}
      >
        <Alert color="secondary">
          <div>
            <AiOutlineInfoCircle />{' '}
            <span className={style.fs_14}>
            此頁面只出現物流狀態為【貨到門市】後10天未取件的訂單
          </span>
          </div>
        </Alert>
        <Card className={style.search_card}>
          <div className={style.card_header}>搜尋條件</div>
          <div className={style.card_body}>
            <form>
              <div className="d-flex flex-wrap w-100">
                <div
                    className={style.formGroup}
                    style={{ marginRight: '1.5rem', width: '100%' }}
                >
                  <label className="col-form-label text-nowrap mr-2">
                    關鍵字
                  </label>
                  <input
                      type="text"
                      className={`form-control ${style['form-keyword']}`}
                      name="keyword"
                      placeholder="會員電話、收件人、收件人電話、商品名稱"
                      onChange={handleChange}
                      value={values.keyword}
                  />
                </div>
                <div
                    className={style.formGroup}
                    style={{ marginRight: '1.5rem' }}
                >
                  <label className="col-form-label mr-2">商品交期</label>
                  <SearchSelect
                      className={style['form-select-short']}
                      options={orderOptionsInfo?.deliveryType}
                      emptyVal={0}
                      name="deliveryType"
                      setFieldValue={setFieldValue}
                      values={values}
                      style={{ margin: 0 }}
                  />
                </div>
                <div
                    className={style.formGroup}
                    style={{ marginRight: '1.5rem' }}
                >
                  <label className="col-form-label mr-2">門市</label>
                  <SearchSelect
                      className={style['form-select']}
                      options={uuoptionsInfo.map(i => ({
                        code: i.suppliercode,
                        name: i.companyname,
                      }))}
                      emptyVal={0}
                      emptyLabel="全部門市"
                      name="suppliercode"
                      setFieldValue={setFieldValue}
                      values={values}
                      style={{ margin: 0 }}
                  />
                </div>
                <div
                    className={style.formGroup}
                    style={{ marginRight: '1.5rem' }}
                >
                  <label className="col-form-label mr-2 text-nowrap">
                    日期區間
                  </label>
                  <Input
                      type="select"
                      className={style['form-select-medium']}
                      name="timeType"
                      onChange={handleChange}
                      value={values.timeType}
                      style={{ margin: 0 }}
                  >
                    <option value="訂購時間">訂購時間</option>
                    <option value="預購出貨日">預購出貨日</option>
                    <option value="確認時間">確認時間</option>
                    <option value="轉單時間">轉單時間</option>
                  </Input>
                  <DatePicker
                      className="form-control"
                      dateFormat="yyyy/MM/dd p"
                      showTimeSelect
                      selected={
                        values.startTime
                            ? moment(values.startTime).toDate()
                            : moment().subtract(7, 'days').toDate()
                      }
                      name="startTime"
                      onChange={date => {
                        setFieldValue('startTime', date);
                      }}
                      selectsStart
                  />
                  <span style={{ margin: '1rem' }}>~</span>
                  <DatePicker
                      className="form-control"
                      dateFormat="yyyy/MM/dd p"
                      showTimeSelect
                      selected={
                        values.endTime
                            ? moment(values.endTime).toDate()
                            : moment().toDate()
                      }
                      name="endTime"
                      onChange={date => {
                        setFieldValue('endTime', date);
                      }}
                      selectsEnd
                      minDate={values.startTime}
                  />
                </div>
                <div
                    className={style.formGroup}
                    style={{ marginRight: '1.5rem' }}
                >
                  <label className="col-form-label mr-2 text-nowrap">編號</label>
                  <Input
                      type="select"
                      className={style['form-select-short']}
                      name="orderNumberType"
                      onChange={handleChange}
                      value={values.orderNumberType}
                      style={{ margin: 0 }}
                  >
                    <option value="主單編號">主單編號</option>
                    <option value="訂單編號">訂單編號</option>
                  </Input>
                  <Input
                      type="text"
                      className={style['form-input-order-number']}
                      name="orderNumber"
                      onChange={handleChange}
                      value={values.orderNumber}
                  />
                </div>
              </div>
            </form>
            <div className={style.button_position}>
              <Button
                  type="button"
                  className={style.modal_button_cancel}
                  onClick={() => {
                    handleReset();
                  }}
              >
                取消
              </Button>
              <Button
                  type="button"
                  className={style.modal_button_submit}
                  onClick={() => {
                    setFieldValue('page', 1);
                    handleSubmit();
                  }}
              >
                查詢
              </Button>
            </div>
          </div>
        </Card>
        <TableList
            onChangePage={handleChangePage}
            onAction={handleAction}
            onActionOne={handleActionOne}
            onActionCancelOne={handleActionCancelOne}
            onActionCancel={handleActionCancel}
            onToggleDiscountModal={setIsDiscountModalOpen}
            onToggleOrderRemarkModal={setIsOrderRemarkModalOpen}
            setOrderInfo={setOrderInfo}
            setCurrentOrderItemId={setCurrentId}
            onToggleDiscountActivityModal={setIsDiscountActivityModalOpen}
        />
        {isDiscountModalOpen && (
            <DiscountDetailModal
                isOpen={isDiscountModalOpen}
                toggle={setIsDiscountModalOpen}
            />
        )}
        {isOrderRemarkModalOpen && orderInfo && (
            <OrderRemarkModal
                isOpen={isOrderRemarkModalOpen}
                toggle={setIsOrderRemarkModalOpen}
                info={orderInfo}
                callBack={handleSubmit}
            />
        )}
        {isDiscountActivityModalOpen && (
            <DiscountActivityDetailModal
                isOpen={isDiscountActivityModalOpen}
                toggle={setIsDiscountActivityModalOpen}
                id={currentId}
            />
        )}
      </Layout>
  );
};
export default StoreOrdersCancel;
